// Copied from advisor-3.0/src/components/User/UserAvatar.js
// Changes: useHistory -> useNavigate, TS types
import { useState, MouseEvent } from 'react';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const getInitials = (name: string): string => {
  const words = name.trim().split(' ');
  if (words.length === 1) {
    return `${words[0][0]}${words[0][1] || words[0][0]}`.toUpperCase();
  }
  const firstNameInitial = words[0][0];
  const lastNameInitial = words[words.length - 1][0];
  return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
};

interface UserAvatarProps {
  name: string;
}

const UserAvatar = ({ name }: UserAvatarProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    window.location.href = '/ns?logout=true';
  };

  const open = Boolean(anchorEl);
  const id = open ? 'avatar-menu' : undefined;

  return (
    <div>
      <IconButton
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          display: 'flex',
          alignItems: 'center',
          textTransform: 'none',
          '&:hover': { backgroundColor: 'transparent' },
          '&:focus': { backgroundColor: 'transparent', outline: 'none' },
          '&:active': { backgroundColor: 'transparent', outline: 'none', boxShadow: 'none' },
        }}
        disableRipple={true}
        disableFocusRipple={true}
      >
        <Avatar sx={(theme) => ({
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
        })}>{getInitials(name)}</Avatar>
        <span style={{ marginLeft: 8, marginRight: 8, fontSize: '16px' }}>{name}</span>
        <ArrowDropDownIcon />
      </IconButton>
      <Menu id={id} anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
        <MenuItem onClick={handleLogout}>Sign out</MenuItem>
      </Menu>
    </div>
  );
};

export default UserAvatar;
